import { queryOptions } from "@tanstack/react-query"
import { cartKeys } from "@lib/query-keys"
import { getCartAction } from "@modules/cart/actions"

/**
 * React Query options for cart data.
 *
 * Uses getCartAction (a server action) to fetch cart from the backend.
 * The cartId parameter controls the query key for cache isolation.
 *
 * The query is always enabled: getCartAction reads the cart id from the
 * server-side cookie, so it works even before the client knows the id
 * (fresh page load, second tab). Disabling on a null client id was why a
 * refresh / second tab showed an empty cart despite a valid cookie.
 */
export function cartQueryOptions(cartId: string | null) {
  return queryOptions({
    queryKey: cartId ? cartKeys.detail(cartId) : cartKeys.pending(),
    queryFn: async () => {
      const result = await getCartAction()
      return result.success ? result.cart ?? null : null
    },
    enabled: true,
    staleTime: 30_000,
  })
}
